<template>
  <div class="dataKanban">
    <div class="exit" @click="exit"></div>
    <div class="title">宇亨物联网平台数据看板</div>
    <div class="flex">
      <div class="leftItem">
        <div class="date">{{ time }}</div>
        <div class="flex item1 mb-12 between">
          <div v-for="item in OperatorStatisticsList">
            <div class="num mb-10">{{ item.value }}</div>
            <div class="foot">{{ item.key }}</div>
          </div>
        </div>
        <div class="item2 mb-12 flex">
          <div v-for="item in PharmacyStatisticsList">
            <div class="num mb-10">{{ item.value }}</div>
            <div class="foot">{{ item.key }}</div>
          </div>
        </div>
        <div class="item3 mb-12">
          <div class="flex topUi">
            <div v-for="item in DeviceStatisticsList">
              <div class="num mb-10">{{ item.value }}</div>
              <div class="foot">{{ item.key }}</div>
            </div>
          </div>
          <div ref="WorkloadPieChart" class="WorkloadPieChart"></div>
        </div>
        <div class="item4 mb-12 flex between">
          <div v-for="item in MaintainStatisticList">
            <div class="numBg">{{ item.value }}</div>
            <div class="foot">{{ item.key }}</div>
          </div>
        </div>
        <div class="item5 mb-12">
          <div class="flex topUi">
            <div v-for="item in ExceptionDealStatisticList">
              <div class="num mb-10">{{ item.value }}</div>
              <div class="foot">{{ item.key }}</div>
            </div>
          </div>
          <div class="flex preBox">
            <div>
              <div ref="kindPie" class="kindPie"></div>
              <div class="foot">异常种类分布</div>
            </div>
            <div>
              <div ref="facilityPie" class="facilityPie"></div>
              <div class="foot">异常设备型号分布</div>
            </div>
          </div>
        </div>
      </div>
      <div class="centerItem">
        <div class="flex dataCard between">
          <div class="flex">
            <div class="tip1">今日</div>
            <div class="tip2 flex">
              <div v-for="item in TodayPatientStatistic">
                <div class="num">{{ item.value }}</div>
                <div class="foot">{{ item.key }}</div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="tip1">累计</div>
            <div class="tip2 flex">
              <div v-for="item in PrescriptionStatistic">
                <div class="num">{{ item.value }}</div>
                <div class="foot">{{ item.key }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="map">
          <div class="tabMap">
            <div :class="{atv: MapActive === 0}" @click="tabMap(0)">药房分布</div>
            <div :class="{atv: MapActive === 1}" @click="tabMap(1)">运营商分布</div>
          </div>
          <echartsMap :mapData="mapData"></echartsMap>
        </div>
        <div class="flex ranking between">
          <div>
            <div class="milk">运营商药房数量排名</div>
            <div class="flex between">
              <div class="previousPage" @click="PharmacyPrevious"></div>
              <div class="aresRight bb">
                <div class="flex align-center linelist between" v-for="(item,index) in PharmacyAmount"
                     :key="index + 'sale'">
                  <div class="name" :title="item.key">NO.{{ index + 1 }} &nbsp;&nbsp; {{ item.key }}</div>
                  <div class="line">
                    <div :style="{width: item.percentage + '%'}"></div>
                  </div>
                  <div class="round">
                    {{ item.value }}
                  </div>
                </div>
              </div>
              <div class="nextPage" @click="PharmacyNextPage"></div>
            </div>
          </div>
          <div>
            <div class="milk">运营商设备数量排名</div>
            <div class="flex between">
              <div class="previousPage" @click="DevicePrevious"></div>
              <div class="aresRight bb">
                <div class="flex align-center linelist between" v-for="(item,index) in DeviceAmount"
                     :key="index + 'sale'">
                  <div class="name" :title="item.key">NO.{{ index + 1 }} &nbsp;&nbsp; {{ item.key }}</div>
                  <div class="line">
                    <div :style="{width: item.percentage + '%'}"></div>
                  </div>
                  <div class="round">
                    {{ item.value }}
                  </div>
                </div>
              </div>
              <div class="nextPage" @click="DeviceNextPage"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightItem">
        <div class="item1">
          <div class="titleName">各型号设备累计销售量</div>
          <div ref="rightLine" class="rightLine" style="height: 160px;width: 100%;margin-bottom: 20px">
          </div>
          <div class="titleFlex flex">
            <div class="ins">设备销售趋势图</div>
            <div class="flex dateDome">
              <div :class="{atv: deviceActive === 0}" @click="deviceTime(0)">月</div>
              <div :class="{atv: deviceActive === 1}" @click="deviceTime(1)">年</div>
            </div>
          </div>
          <div ref="salesChart" class="salesChart"></div>
        </div>
        <div class="item2">
          <div class="titleFlex flex">
            <div class="ins">耗材消耗趋势图</div>
            <div class="flex dateDome">
              <div :class="{atv: CupSale === 0}" @click="CupTime(0)">月</div>
              <div :class="{atv: CupSale === 1}" @click="CupTime(1)">年</div>
            </div>
          </div>
          <div ref="consumableChart" class="consumableChart">
          </div>
          <div class="titleFlex flex">
            <div class="ins">药品销售趋势图</div>
            <div class="flex dateDome">
              <div :class="{atv: durgState === 0}" @click="durgTime(0)">月</div>
              <div :class="{atv: durgState === 1}" @click="durgTime(1)">年</div>
            </div>
          </div>
          <div ref="drugChart" class="drugChart">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import echartsMap from '@/components/echartsMap'
import dataInput from "@/components/dataInput";

export default {
  name: "dataKanban",
  data() {
    return {
      msg: "",
      saleInfoList: [
        {
          workerName: '成都市洞子口大药房',
          percentage: 88,
          amount: 1223
        }
      ],
      OperatorStatisticsList: [],
      PharmacyStatisticsList: [],
      DeviceStatisticsList: [],
      MaintainStatisticList: [],
      ExceptionDealStatisticList: [],
      TodayPatientStatistic: [],
      PrescriptionStatistic: [],
      PharmacyAmount: [],
      PharmacyPage: 1,
      cutPharmacyAmount: [],
      DeviceAmount: [],
      DevicePage: 1,
      cutDeviceAmount: [],
      deviceActive: 0,//设备销售图默认月
      CupSale: 0,//设备耗材默认月
      durgState: 0,//药品
      MapActive: 0,//地图
      mapData:[],
      time:'',
      interval:'',
      GetOtherConfig:'',
    }
  },
  components: {
    //someComponent
    echartsMap
  },
  created() {
    this.GetOtherConfig = JSON.parse(window.utils.storage.getter("GetOtherConfig"))
  },
  methods: {
    exit(){
      clearInterval(this.interval)
      this.$router.go(-1);
    },
    //
    WorkloadPieCharts(data) {
      let WorkloadPieCharts = echarts.init(this.$refs.WorkloadPieChart);
      WorkloadPieCharts.setOption({
        tooltip: {
          trigger: 'item'
        },
        color: ["#9362E7", "#0C90FF", "#41BFDF"],
        series: [
          {
            type: 'pie',
            radius: ['50%', '80%'],
            label: {
              color: '#8fa5ff'
            },
            data: data
          }
        ]
      },true)
    },
    kindPie(data) {
      this.kindPie = echarts.init(this.$refs.kindPie);
      this.kindPie.setOption({
        tooltip: {
          trigger: 'item'
        },
        color: ["#9362E7", "#0C90FF", "#41BFDF", "#CCFF99", "#99CCFF", "#66CCCC"],
        series: [
          {
            type: 'pie',
            radius: ['50%', '80%'],
            label: {
              show: false,
              color: '#8fa5ff',
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '12',
              }
            },
            data: data
          }
        ]
      })
    },
    facilityPie(data) {
      this.facilityPie = echarts.init(this.$refs.facilityPie);
      this.facilityPie.setOption({
        tooltip: {
          trigger: 'item'
        },
        color: ["#9362E7", "#0C90FF", "#41BFDF", "#CCFF99", "#99CCFF", "#66CCCC"],
        series: [
          {
            type: 'pie',
            radius: ['50%', '80%'],
            label: {
              show: false,
              color: '#8fa5ff',
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '12',
              }
            },
            data: data
          }
        ]
      })
    },
    rightLine(key, value) {
      this.rightLine = echarts.init(this.$refs.rightLine);
      this.rightLine.setOption(
          {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              top: '15%',
              right: '3%',
              left: '5%',
              bottom: '16%'
            },
            xAxis: [{
              type: 'category',
              data: key,
              axisLine: {
                lineStyle: {
                  color: 'rgba(255,255,255,0.12)'
                },
              },
              axisLabel: {
                margin: 10,
                interval: 0,
                color: '#e2e9ff',
                formatter:function(value)
                {
                  const length = value.length
                  if (length > 5) {
                    var str = ''
                    str = value.substring(0, 5) + '...'
                    return str
                  } else {
                    return value
                  }
                },
                textStyle: {
                  fontSize: 12
                },
              },
              itemStyle: {
                normal: {
                  color: ["rgba(2,195,241,0.1)", "rgba(83, 229, 104, 0.1)", "rgba(161, 84, 233, 0.1)"],
                }
              },
            }],
            yAxis: [{
              show: false,
              axisLabel: {
                formatter: '{value}',
                color: '#e2e9ff',
              },
              axisLine: {
                show: false
              },
              splitLine: {
                lineStyle: {
                  color: 'rgba(255,255,255,0.12)'
                }
              }
            }],
            series: [{
              type: 'bar',
              data: value,
              barWidth: '15px', // 柱状图宽度
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(0,244,255)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: 'rgb(91,110,227)' // 100% 处的颜色
                  }], false),
                  barBorderRadius: [30, 30, 0, 0],
                  shadowColor: 'rgba(0,160,221,1)',
                  shadowBlur: 4,
                }
              },
              label: {
                show: true,
                position: [10, -15],
                color: '#ffffff',
                fontSize: 10,
                align: 'center',
              }
            }]
          }
      )
    },
    salesChart(xAxisData, yAxisTitle, yData) {
      let salesChart = echarts.init(this.$refs.salesChart);
      const color = ['#0090FF', '#FFC005', '#36CE9E', '#FF515A', '#8B5CFF', '#00CA69']
      const hexToRgba = (hex, opacity) => {
        let rgbaColor = ''
        const reg = /^#[\da-f]{6}$/i
        if (reg.test(hex)) {
          rgbaColor = `rgba(${parseInt('0x' + hex.slice(1, 3))},${parseInt('0x' + hex.slice(3, 5))},${parseInt('0x' + hex.slice(5, 7))},${opacity})`
        }
        return rgbaColor
      }
      const lineStyle = (index) => {
        return {
          normal: {
            color: color[index],
            shadowColor: hexToRgba(color[index], 0.5),
            shadowBlur: 3,
            shadowOffsetY: 8
          }
        }
      }
      const areaStyle = (index) => {
        return {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                [{
                  offset: 0,
                  color: hexToRgba(color[index], 0.3)
                }, {
                  offset: 1,
                  color: hexToRgba(color[index], 0.1)
                }]
            ),
            shadowColor: hexToRgba(color[index], 0.1),
            shadowBlur: 10
          }
        }
      }
      salesChart.setOption(
          {
            color: color,
            grid: {
              top: 30,
              left: 40,
              right: 0,
              bottom: 30
            },
            title: {
              text: '数量(台)',
              textStyle: {
                fontSize: 12,
                color: '#74ddfb',
              }
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'line'
              },
              extraCssText: 'font-size:14px;line-height:24px;color:#567;background:#fff;box-shadow:0 0 3px rgba(0, 0, 0, 0.2)',
              formatter: function (params) {
                let html = ''
                params.forEach(v => {
                  html += `<div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color[v.componentIndex]};"></span>${v.seriesName}<span style="color:${color[v.componentIndex]};font-size:18px;font-weight:700">${v.value}</span>台`
                })
                return html
              }
            },
            xAxis: {
              axisLine: {
                lineStyle: {
                  color: '#74ddfb',
                  width: 1,//这里是为了突出显示加上的
                }
              },
              data: xAxisData
            },
            yAxis: {
              axisLine: {
                lineStyle: {
                  color: '#74ddfb',
                  width: 1,//这里是为了突出显示加上的
                }
              }
            },
            series: [{
              name: yAxisTitle[0],
              type: 'line',
              data: yData.x,
              smooth: true,
              symbolSize: 6,
              lineStyle: lineStyle(0),
              areaStyle: areaStyle(0)
            }, {
              name: yAxisTitle[1],
              type: 'line',
              data: yData.y,
              smooth: true,
              symbolSize: 6,
              lineStyle: lineStyle(1),
              areaStyle: areaStyle(1)
            }, {
              name: yAxisTitle[2],
              type: 'line',
              data: yData.z,
              smooth: true,
              symbolSize: 6,
              lineStyle: lineStyle(2),
              areaStyle: areaStyle(2)
            }]
          }
      )
    },
    consumableChart(xAxisData, yAxisTitle, yData) {
      let consumableChart = echarts.init(this.$refs.consumableChart);
      const color = ['#efa8ff', '#4cc2f8', '#36CE9E', '#FF515A', '#8B5CFF', '#00CA69']
      const hexToRgba = (hex, opacity) => {
        let rgbaColor = ''
        const reg = /^#[\da-f]{6}$/i
        if (reg.test(hex)) {
          rgbaColor = `rgba(${parseInt('0x' + hex.slice(1, 3))},${parseInt('0x' + hex.slice(3, 5))},${parseInt('0x' + hex.slice(5, 7))},${opacity})`
        }
        return rgbaColor
      }
      const lineStyle = (index) => {
        return {
          normal: {
            color: color[index],
            shadowColor: hexToRgba(color[index], 0.5),
            shadowBlur: 3,
            shadowOffsetY: 8
          }
        }
      }
      const areaStyle = (index) => {
        return {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                [{
                  offset: 0,
                  color: hexToRgba(color[index], 0.3)
                }, {
                  offset: 1,
                  color: hexToRgba(color[index], 0.1)
                }]
            ),
            shadowColor: hexToRgba(color[index], 0.1),
            shadowBlur: 10
          }
        }
      }
      consumableChart.setOption(
          {
            color: color,
            grid: {
              top: 30,
              left: 50,
              right: 0,
              bottom: 30
            },
            title: {
              text: '数量(个)',
              textStyle: {
                fontSize: 12,
                color: '#74ddfb',
              }
            },
            legend: {
              icon: 'rect',
              itemHeight: 12,
              itemWidth: 12,
              top: 0,
              right: 10,
              textStyle: {
                fontSize: 12,
                color: '#567'
              }
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'line'
              },
              extraCssText: 'font-size:14px;line-height:24px;color:#567;background:#fff;box-shadow:0 0 3px rgba(0, 0, 0, 0.2)',
              formatter: function (params) {
                let html = ''
                params.forEach(v => {
                  html += `<div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color[v.componentIndex]};"></span>${v.seriesName}<span style="color:${color[v.componentIndex]};font-size:18px;font-weight:700">${v.value}</span>`
                })
                return html
              }
            },
            xAxis: {
              axisLine: {
                lineStyle: {
                  color: '#74ddfb',
                  width: 1,//这里是为了突出显示加上的
                }
              },
              data: xAxisData
            },
            yAxis: {
              axisLine: {
                lineStyle: {
                  color: '#74ddfb',
                  width: 1,//这里是为了突出显示加上的
                }
              }
            },
            series: [{
              name: yAxisTitle[0],
              type: 'line',
              data: yData[0].data,
              smooth: true,
              symbolSize: 6,
              lineStyle: lineStyle(0),
              areaStyle: areaStyle(0)
            }, {
              name: yAxisTitle[1],
              type: 'line',
              data:  yData[1].data,
              smooth: true,
              symbolSize: 6,
              lineStyle: lineStyle(1),
              areaStyle: areaStyle(1)
            }]
          }
      )
    },
    drugChart(xAxisData,yData) {
      let drugChart = echarts.init(this.$refs.drugChart);
      const color = ['#efa8ff', '#4d24ed', '#4cc2f8', '#94dcf3', '#8B5CFF', '#00CA69']
      const hexToRgba = (hex, opacity) => {
        let rgbaColor = ''
        const reg = /^#[\da-f]{6}$/i
        if (reg.test(hex)) {
          rgbaColor = `rgba(${parseInt('0x' + hex.slice(1, 3))},${parseInt('0x' + hex.slice(3, 5))},${parseInt('0x' + hex.slice(5, 7))},${opacity})`
        }
        return rgbaColor
      }
      const lineStyle = (index) => {
        return {
          normal: {
            color: color[index],
            shadowColor: hexToRgba(color[index], 0.5),
            shadowBlur: 3,
            shadowOffsetY: 8
          }
        }
      }
      const areaStyle = (index) => {
        return {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                [{
                  offset: 0,
                  color: hexToRgba(color[index], 0.3)
                }, {
                  offset: 1,
                  color: hexToRgba(color[index], 0.1)
                }]
            ),
            shadowColor: hexToRgba(color[index], 0.1),
            shadowBlur: 10
          }
        }
      }
      drugChart.setOption(
          {
            color: color,
            grid: {
              top: 30,
              left: 50,
              right: 0,
              bottom: 30
            },
            title: {
              text: '数量(台)',
              textStyle: {
                fontSize: 12,
                color: '#74ddfb',
              }
            },
            legend: {
              icon: 'rect',
              itemHeight: 12,
              itemWidth: 12,
              top: 0,
              right: 10,
              textStyle: {
                fontSize: 12,
                color: '#567'
              }
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'line'
              },
              extraCssText: 'font-size:14px;line-height:24px;color:#567;background:#fff;box-shadow:0 0 3px rgba(0, 0, 0, 0.2)',
              formatter: function (params) {
                let html = ''
                params.forEach(v => {
                  html += `<div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color[v.componentIndex]};"></span>${v.seriesName}<span style="color:${color[v.componentIndex]};font-size:18px;font-weight:700">${v.value}</span>`
                })
                return html
              }
            },
            xAxis: {
              axisLine: {
                lineStyle: {
                  color: '#74ddfb',
                  width: 1,//这里是为了突出显示加上的
                }
              },
              data: xAxisData
            },
            yAxis: {
              axisLine: {
                lineStyle: {
                  color: '#74ddfb',
                  width: 1,//这里是为了突出显示加上的
                }
              }
            },
            series: [{
              name: '剂量',
              type: 'line',
              data: yData.dosage,
              smooth: true,
              symbolSize: 6,
              lineStyle: lineStyle(0),
              areaStyle: areaStyle(0)
            }, {
              name: '药杯数',
              type: 'line',
              data: yData.cupAmount,
              smooth: true,
              symbolSize: 6,
              lineStyle: lineStyle(1),
              areaStyle: areaStyle(1)
            }, {
              name: '处方数',
              type: 'line',
              data: yData.prescriptionAmount,
              smooth: true,
              symbolSize: 6,
              lineStyle: lineStyle(2),
              areaStyle: areaStyle(2)
            },{
              name: '处方天量',
              type: 'line',
              data: yData.prescriptionDaysAmount,
              smooth: true,
              symbolSize: 6,
              lineStyle: lineStyle(3),
              areaStyle: areaStyle(4)
            }
            ]
          },
      )
    },
    init() {
      this.axios // 供应商数量信息
          .get("/Board/PFboard/OperatorStatistics")
          .then((res) => {
            this.OperatorStatisticsList = res
          })
      this.axios //药房数量信息
          .get("/Board/PFboard/PharmacyStatistics")
          .then((res) => {
            this.PharmacyStatisticsList = res
          })
      this.axios //保养信息统计
          .get("/Board/PFboard/MaintainStatistic")
          .then((res) => {
            this.MaintainStatisticList = res
          })
      this.axios //异常处理数据统计
          .get("/Board/PFboard/ExceptionDealStatistic")
          .then((res) => {
            this.ExceptionDealStatisticList = res
          })
      this.axios //异常按类型统计
          .get("/Statistics/PFExceptionDealStatistic/GetExceptionStatisticByExceptionType")
          .then((res) => {
            res.forEach(item => {
              item.name = item.itemName
              item.value = item.count
            })
            this.kindPie(res)
          })
      this.axios //异常按设备类型统计
          .get("/Statistics/PFExceptionDealStatistic/GetExceptionStatisticByDeviceType")
          .then((res) => {
            res.forEach(item => {
              item.name = item.itemName
              item.value = item.count
            })
            this.facilityPie(res)
          })
      this.axios //今日患者信息统计
          .get("/Board/PFboard/TodayPatientStatistic")
          .then((res) => {
            this.TodayPatientStatistic = res
          })
      this.axios //处方数据统计
          .get("/Board/PFboard/PrescriptionStatistic")
          .then((res) => {
            this.PrescriptionStatistic = res
          })
      this.axios //代理商药房排名
          .get("/Board/PFboard/OperatorPharmacyAmount", {params: {topX: 100}})
          .then((res) => {
            this.cutPharmacyAmount = res
            this.PharmacyAmount = this.getitems(this.cutPharmacyAmount, this.PharmacyPage,  this.GetOtherConfig.pharmacyPage)
            let max
            this.PharmacyAmount.forEach((item, index) => {
              if (index === 0) {
                max = item.value
              }
              item.percentage = item.value * 100 / max
            })
          })
      this.axios //设备总数排名
          .get("/Board/PFboard/OperatorDeviceAmount", {params: {topX: 100}})
          .then((res) => {
            this.cutDeviceAmount = res
            this.DeviceAmount = this.getitems(this.cutDeviceAmount, this.DevicePage,  this.GetOtherConfig.equipmentPage)
            let max
            this.DeviceAmount.forEach((item, index) => {
              if (index === 0) {
                max = item.value
              }
              item.percentage = item.value * 100 / max
            })
          })
      this.axios //获取型号信息统计
          .get("/Board/PFboard/DeviceTypeStatistic")
          .then((res) => {
            let key = []
            let value = []
            res.forEach(item => {
              key.push(item.key)
              value.push(item.value)
            })
            this.rightLine(key, value)
          })
    },
    PharmacyPrevious() { // 运营商药房上一页
      if (this.PharmacyPage <= 1) {
        this.PharmacyPage = 1
      } else {
        this.PharmacyPage -= 1
      }
      this.PharmacyAmount = this.getitems(this.cutPharmacyAmount, this.PharmacyPage, this.GetOtherConfig.pharmacyPage)
      let max
      this.PharmacyAmount.forEach((item, index) => {
        if (index === 0) {
          max = item.value
        }
        item.percentage = item.value * 100 / max
      })
    },
    PharmacyNextPage() { // 运营商药房下一页
      if (this.PharmacyPage >= (this.cutPharmacyAmount.length / this.GetOtherConfig.pharmacyPage)) {
        this.PharmacyPage = 1
      } else {
        this.PharmacyPage += 1
      }
      this.PharmacyAmount = this.getitems(this.cutPharmacyAmount, this.PharmacyPage, this.GetOtherConfig.pharmacyPage)
      let max
      this.PharmacyAmount.forEach((item, index) => {
        if (index === 0) {
          max = item.value
        }
        item.percentage = item.value * 100 / max
      })
    },
    DevicePrevious() { // 运营商药房上一页
      if (this.DevicePage <= 1) {
        this.DevicePage = 1
      } else {
        this.DevicePage -= 1
      }
      this.DeviceAmount = this.getitems(this.cutDeviceAmount, this.DevicePage, this.GetOtherConfig.equipmentPage)
      let max
      this.DeviceAmount.forEach((item, index) => {
        if (index === 0) {
          max = item.value
        }
        item.percentage = item.value * 100 / max
      })
    },
    DeviceNextPage() { // 运营商药房下一页
      if (this.DevicePage >= (this.cutDeviceAmount.length / this.GetOtherConfig.equipmentPage)) {
        this.DevicePage = 1
      } else {
        this.DevicePage += 1
      }
      this.DeviceAmount = this.getitems(this.cutDeviceAmount, this.DevicePage, this.GetOtherConfig.equipmentPage)
      let max
      this.DeviceAmount.forEach((item, index) => {
        if (index === 0) {
          max = item.value
        }
        item.percentage = item.value * 100 / max
      })
    },
    getitems(target, page, pagesize) { // 前端分页
      let start = (page - 1) * pagesize;
      let end = page * pagesize > target.length ? target.length : page * pagesize;
      let result = [];
      for (start; start < end; start++) {
        result.push(target[start]);
      }
      return result;
    },
    // 设备销售趋势图
    deviceTime(i) {
      this.deviceActive = i
      if (i === 0) {//月
        let data = {
          start: this.month(6),
          end: this.month(0)
        }
        let url = '/Board/PFboard/DeviceTypeSaleStatisticByMonth'
        this.deviceeSale(url, data)
      } else {
        let data = {
          startYear: 2019,
          endYear: new Date().getFullYear(),
        }
        let url = '/Board/PFboard/DeviceTypeSaleStatistic'
        this.deviceeSale(url, data)
      }
    },
    deviceeSale(url, data) {
      this.axios //设备各型号销售曲线
          .get(url, {params: data})
          .then((res) => {
            let xAxisData = []
            let yData = {
              x: [],
              y: [],
              z: []
            }
            res.forEach(item => {
              if (item.key !== 0) {
                xAxisData.push(item.key)
              }
              if (item.value) {
                item.value.forEach((item, index) => {
                  if (index === 0) {
                    yData.x.push(item.value)
                  }
                  if (index === 1) {
                    yData.y.push(item.value)
                  }
                  if (index === 2) {
                    yData.z.push(item.value)
                  }
                })
              }
            })
            let yAxisTitle = []
            res[0].value.forEach((item, index) => {
              yAxisTitle.push(item.key)
            })
            this.salesChart(xAxisData, yAxisTitle, yData)
          })
    },
    CupTime(i) { //耗材消耗
      this.CupSale = i
      let url = ''
      let data = {}
      if (i === 0) {
        url = '/Statistic/PFStatistic/GetMonthCupStatistics'
        data = {
          start: this.month(6),
          end: this.month(0)
        }
      } else {
        url = '/Statistic/PFStatistic/GetYearCupStatistics'
        data = {
          yearStart: 2019,
          yearEnd: new Date().getFullYear(),
        }
      }
      this.cupSale(url, data)
    },
    // list
    cupSale(url, data) {
      this.axios
          .get(url, {params: data})
          .then((res) => {
            this.tableData = res
            console.log(res)
            let arrdata = {
              date: [],
              title: [],
            }
            let groups = [];
            this.tableData.forEach(item => {
              let target = null;
              for (let i in groups) {
                if (groups[i].name == item.cupTypeName) {
                  target = groups[i];
                  break;
                }
              }
              if (target == null) {
                arrdata.title.push(item.cupTypeName)
                groups.push({
                  name: item.cupTypeName,
                  data: [item.usedAmount],
                });
              } else {
                target.data.push(item.usedAmount);
              }
              switch (this.CupSale) {
                case 0:
                  arrdata.date.push(item.year + '-' + item.month)
                  break;
                default :
                  arrdata.date.push(item.year)
              }
            })
         let xAxisData=this.unique(arrdata.date)
         let yAxisTitle=arrdata.title
         let yData=groups
          this.consumableChart(xAxisData,yAxisTitle,yData)
          })
    },
    //药品销售趋势图
    durgTime(i){
      this.durgState = i
      let url = ''
      let data = {}
      if (i === 0) {
        url = '/Statistic/PFStatistic/GetMonthStatisticsForOperatorAndGroupByMonth'
        data = {
          start: this.month(6),
          end: this.month(0)
        }
      } else {
        url = '/Statistic/PFStatistic/GetYearStatisticsForOperatorAndGroupByYear'
        data = {
          start: 2019,
          end: new Date().getFullYear(),
        }
      }
      this.drugSale(url, data)
    },
    drugSale(url,data){
      this.axios
          .get(url, {params: data})
          .then((res) => {
            let yData={
              cupAmount:[],
              dosage:[],
              prescriptionAmount:[],
              prescriptionDaysAmount:[],
            }
            let xAxisData=[]
            res.forEach(item => {
              yData.cupAmount.push(item.cupAmount)
              yData.dosage.push(item.dosage)
              yData.prescriptionAmount.push(item.prescriptionAmount)
              yData.prescriptionDaysAmount.push(item.prescriptionDaysAmount)
              switch (this.durgState) {
                case 0:
                  xAxisData.push(item.year + '-' + item.month)
                  break;
                default :
                  xAxisData.push(item.year)
              }
            })
            this.drugChart(xAxisData,yData)
          })
    },
    unique(arr) { // 数组去重
      return Array.from(new Set(arr))
    },
// 月份
    month(i) {
      var time = new Date();
      time.setTime(time.getTime());
      var s2 = time.getFullYear() + "-" + (time.getMonth() + 1) + "-" + time.getDate();
      var monthNum = i; //要减的月数(6)自己定义
      var dateArr = s2.split('-'); //s2当前时间
      var year = dateArr[0]; //获取当前日期的年份
      var month = dateArr[1]; //获取当前日期的月份
      var day = dateArr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - monthNum;
      if (month2 <= 0) {
        year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : parseInt(month2) / 12);
        month2 = 12 - (Math.abs(month2) % 12);
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      return year2 + '-' + month2 + '-' + day2;
    },
    tabMap(i){
      this.MapActive=i
      if(i===0)
        this.mapPharmacyList()
      else
        this.mapOperatorList()
    },
    // 地图
    mapOperatorList(){
      this.axios //代理商
          .get("/Board/PFboard/GetAreaOperatorInfo")
          .then((res) => {
            this.mapData=res
            this.mapData.forEach(item=>{
              item.value=item.count
              let str=item.name.substr(item.name.length-1,1)
              if(str==='省'){
                item.name=item.name.split('省')[0];
              }
              delete item.count
            })
          })
    },
    mapPharmacyList(){
      this.axios //药房排名
          .get("/Board/PFboard/GetAreaPharmacyInfo")
          .then((res) => {
            this.mapData=res
            this.mapData.forEach(item=>{
              item.value= item.count
              let str=item.name.substr(item.name.length-1,1)
              if(str==='省'){
                item.name=item.name.split('省')[0];
              }
              delete item.count
            })
          })
    },
    days(){
      let a = new Array("日", "一", "二", "三", "四", "五", "六");
      let week = new Date().getDay();
      let str = "星期"+ a[week];
      this.time=this.dayjs(new Date()).format('YYYY年MM月DD日 HH:mm') + ' ' +str
    },
    DeviceList(){
      this.axios //设备信息总览
          .get("/Board/PFboard/DeviceStatistics")
          .then((res) => {
            let data = []
            this.DeviceStatisticsList=[]
            res.forEach((item, index) => {
              if (index !== 1) {
                this.DeviceStatisticsList.push(item)
              }
              if (index > 1) {
                let obj = {
                  name: item.key,
                  value: item.value
                }
                data.push(obj)
              }
            })
            this.WorkloadPieCharts(data)
          })
      this.axios //今日患者信息统计
          .get("/Board/PFboard/TodayPatientStatistic")
          .then((res) => {
            this.TodayPatientStatistic = res
          })
      this.axios //处方数据统计
          .get("/Board/PFboard/PrescriptionStatistic")
          .then((res) => {
            this.PrescriptionStatistic = res
          })
    }
  },
  mounted() {
    //
    this.init()
    this.deviceTime(0)
    this.CupTime(0)
    this.durgTime(0)
    this.tabMap(0)
    this.days()
    this.DeviceList()
   this.interval = setInterval(this.DeviceList, 1000);
  }
}
</script>
<style>
@font-face {
  src: url('./YouSheBiaoTiHei.ttf');
  font-family: 'YouSheBiaoTiHei';
  font-weight: normal;
  font-style: normal;
}

@font-face {
  src: url('./digital.woff.ttf');
  font-family: 'digital';
  font-weight: normal;
  font-style: normal;
}

.font-family {
  font-family: 'YouSheBiaoTiHei';
}
</style>
<style lang="scss" scoped>
.dataKanban {
  width: 100%;
  height: 100vh;
  padding: 0 24px;
  background-image: url('../../assets/dataBg.png');
  box-sizing: border-box;
  background-size: 100% 100%;
  transition: 1s;

  .title {
    width: 300px;
    margin: 0 auto;
    text-align: center;
    height: 34px;
    line-height: 34px;
    font-family: YouSheBiaoTiHei;
    font-size: 26px;
    color: #8fa5ff;
  }
  .exit{
    width: 41px;
    height: 41px;
    float: right;
    background: url("../../assets/exit.png");
    background-size: 100% 100%;
    cursor: pointer;
  }
  .leftItem {
    width: 422px;

    .date {
      height: 22px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #4e60bb;
      margin-bottom: 22px;
    }

    .item1 {
      height: 99px;

      & > div {
        width: 132px;
        height: 99px;
        background-image: url('../../assets/leftitem.png');
        background-size: 100% 100%;
        text-align: center;
        padding: 22px 0 10px 0;
        box-sizing: border-box;
      }
    }

    .num {
      height: 34px;
      width: 100%;
      font-family: YouSheBiaoTiHei;
      font-size: 26px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #8fa5ff;
    }

    .foot {
      width: 100%;
      height: 20px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #8fa5ff;
    }

    .item2 {
      width: 422px;
      height: 205px;
      background-image: url('../../assets/daydata1.png');
      background-size: 100% 100%;
      flex-wrap: wrap;
      text-align: center;

      & > div {
        width: 140px;
        height: 80px;
        margin-top: 22px;
      }
    }

    .item3 {
      width: 422px;
      height: 272px;
      background-image: url('../../assets/daydata2.png');
      background-size: 100% 100%;

      .topUi {
        text-align: center;
        padding-top: 22px;

        & > div {
          flex: 1;
        }
      }

      .WorkloadPieChart {
        width: 100%;
        height: 148px;
        margin-top: 20px;
      }
    }

    .item4 {
      width: 422px;
      height: 105px;
      background-image: url('../../assets/daydata3.png');
      background-size: 100% 100%;
      padding: 25px 16px 16px 16px;
      box-sizing: border-box;

      & > div {
        width: 120px;
        text-align: center;

        .numBg {
          background-image: url('../../assets/numbg.png');
          width: 120px;
          height: 28px;
          line-height: 28px;
          background-size: 100% 100%;
          font-family: digital;
          font-size: 26px;
          letter-spacing: 0px;
          color: #74ddfb;
          margin-bottom: 12px;
        }
      }
    }

    .item5 {
      width: 422px;
      height: 246px;
      background-image: url('../../assets/daydata4.png');
      background-size: 100% 100%;

      .topUi {
        text-align: center;
        padding-top: 22px;

        & > div {
          flex: 1;
        }
      }

      .preBox {
        width: 100%;
        height: 168px;
        margin-top: 10px;
        text-align: center;

        & > div {
          flex: 1;
          text-align: center;
        }

        .kindPie, .facilityPie {
          width: 100%;
          height: 110px;
          margin: 0 auto;
        }
      }
    }
  }

  .centerItem {
    width: 958px;
    margin: 0 10px;

    .dataCard {
      margin-top: 44px;

      & > div {
        width: 467px;
        height: 81px;
        background-image: url('../../assets/centerbg.png');
        background-size: 100% 100%;

        .tip1 {
          width: 40px;
          height: 81px;
          font-family: YouSheBiaoTiHei;
          font-size: 18px;
          line-height: 81px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #8fa5ff;
          padding-left: 12px;
        }

        .tip2 {
          width: 80%;
          margin-left: 5%;
          padding-top: 10px;

          & > div {
            flex: 1;
            text-align: center;
          }

          .num {
            font-family: YouSheBiaoTiHei;
            font-size: 26px;
            color: #74ddfb;
          }

          .foot {
            height: 20px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #8fa5ff;
          }
        }
      }
    }

    .map {
      width: 100%;
      margin-top: 25px;
      height: 530px;
      position: relative;

      .tabMap {
        width: 230px;
        height: 28px;
        display: flex;
        align-items: center;
        position: absolute;
        z-index: 99;
        top: 0;
        cursor: pointer;
        div:nth-child(1){
          width: 107px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          background-image: url('../../assets/tab1.png');
          background-size: 100% 100%;
          color: #698ad2;
          margin-left:10px;
        }
        div:nth-child(2){
          width: 107px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          background-image: url('../../assets/tab1.png');
          background-size: 100% 100%;
          color: #698ad2;
          margin-left: -10px;
        }
        .atv{
          background-image: url('../../assets/tab2.png')!important;
          color: #94e7ff!important;
        }
      }
    }

    .ranking {
      width: 958px;
      margin-top: 10px;
      height: 327px;
      background-image: url('../../assets/dataday6.png');
      background-size: 100% 100%;
      padding: 25px 15px 0 15px;
      box-sizing: border-box;

      & > div {
        width: 456px;
        height: 294px;
        background-image: url('../../assets/daydata7.png');
        background-size: 100% 100%;
      }

      .milk {
        font-size: 14px;
        line-height: 30px;
        color: #74ddfb;
        text-align: center;
        width: 100%;
      }

      .previousPage, .nextPage {
        width: 21px;
        height: 73px;
        margin-top: calc(25% - 36px);
        cursor: pointer;
      }

      .previousPage {
        background-image: url('../../assets/previousPage.png');
        background-size: 100% 100%;
      }

      .nextPage {
        background-image: url('../../assets/nextPage.png');
        background-size: 100% 100%;
      }

      .aresRight {
        width: 384px;

        .linelist {
          width: 100%;
          height: 32px;
          line-height: 32px;
          margin-top: 15px;
          color: #74ddfb;

          & > div {
            height: 32px;
          }

          .name {
            max-width: 145px;
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分文字以...显示*/
            margin-right: 10px;
            color: #ffb1d1;

          }

          .line {
            width: 168px;
            height: 12px;
            background: rgb(112, 129, 187, 0.38);
            border-radius: 8px;
            overflow: hidden;

            & > div {
              height: 12px;
              transition: 2s ease-in;
              background-image: linear-gradient(63deg,
                  #455cb6 1%,
                  #c3c3fa 100%);
              border-radius: 8px;
            }
          }

          .round {
            width: 32px;
            height: 32px;
            text-align: center;
            font-size: 16px;
            background-image: linear-gradient(180deg,
                #4cafd5 0%,
                rgba(31, 152, 232, 0.32) 100%);
            border-radius: 50%;
          }
        }
      }
    }
  }

  .rightItem {
    width: 460px;

    .item1 {
      width: 460px;
      height: 481px;
      background-image: url('../../assets/drightbg.png');
      background-size: 100% 100%;
      margin-top: 22px;
      margin-bottom: 12px;

      .titleName {
        width: 178px;
        height: 40px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        line-height: 40px;
        text-align: center;
        color: #74ddfb;
      }

      .titleFlex {
        .ins {
          width: 169px;
          height: 36px;
          background-image: url('../../assets/rightTitle1.png');
          background-size: 100% 100%;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #9dceff;
          text-align: center;
          line-height: 36px;
        }

        .dateDome {
          margin-left: auto;
          width: 200px;
          line-height: 44px;
          display: flex;
          justify-content: flex-end;

          & > div {
            width: 45px;
            margin-top: 10px;
            margin-right: 20px;
            line-height: 26px;
            height: 26px;
            border: 1px solid #5edaff;
            font-size: 14px;
            color: #74ddfb;
            text-align: center;
            border-radius: 10px;
            overflow: hidden;
            cursor: pointer;
          }

          .atv {
            border: 1px solid #5edaff;
            background-color: rgba(105, 210, 255, 0.86);
            color: #0d1749;
          }
        }
      }

      .salesChart {
        height: 210px;
        width: 98%;
        margin-top: 10px;
      }
    }

    .item2 {
      width: 460px;
      height: 493px;
      margin-top: 20px;
      background-image: url('../../assets/dayData8.png');
      background-size: 100% 100%;

      .titleFlex {
        .ins {
          width: 169px;
          height: 36px;
          background-image: url('../../assets/dataDay9.png');
          background-size: 100% 100%;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #9dceff;
          text-align: center;
          line-height: 36px;
        }

        .dateDome {
          margin-left: auto;
          width: 200px;
          line-height: 44px;
          display: flex;
          justify-content: flex-end;

          & > div {
            width: 45px;
            margin-top: 10px;
            margin-right: 20px;
            line-height: 26px;
            height: 26px;
            border: 1px solid #5edaff;
            font-size: 14px;
            color: #74ddfb;
            text-align: center;
            border-radius: 10px;
            overflow: hidden;
            cursor: pointer;
          }

          .atv {
            border: 1px solid #5edaff;
            background-color: rgba(105, 210, 255, 0.86);
            color: #0d1749;
          }
        }
      }

      .consumableChart {
        width: 100%;
        height: 200px;
        margin-top: 10px;
      }

      .drugChart {
        width: 100%;
        height: 200px;
        margin-top: 10px;
      }
    }
  }
}
</style>